import { Box, Button } from "@mui/material";
import { useGridApiContext } from "@mui/x-data-grid";
import { Search } from "lucide-react";
import { EmptyState } from "./AsyncState";

// Column filters can empty any populated table independently of page filters.
export function GridNoResultsOverlay() {
  const apiRef = useGridApiContext();
  return (
    <Box
      sx={{
        height: "100%",
        minHeight: 200,
        display: "grid",
        alignItems: "center",
      }}
    >
      <EmptyState
        compact
        icon={Search}
        title="No matching results"
        description="No records match the table filters. Clear them to see the available records."
        action={
          <Button
            size="small"
            variant="outlined"
            onClick={() =>
              apiRef.current.setFilterModel({
                items: [],
                quickFilterValues: [],
              })
            }
          >
            Clear table filters
          </Button>
        }
      />
    </Box>
  );
}
